import type { ICartService } from './types';
import { CartService } from './CartService';

export const cartService: ICartService = new CartService();

export * from './types';
